import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import ProgressBarContainer from "../ProgressBarContainer/ProgressBarContainer";
import styles from "./Questionnaire.module.scss";
import ColumnsLayout from "../../../partials/ColumnsLayout/ColumnsLayout";
import BtnOptionSelect from "./../../../partials/BtnOptionSelect/BtnOptionSelect";
import Scroll from "./../../../partials/Scroll/Scroll";
import HTMLContent from '../../../partials/HTMLContent'
import ModalContent from "./ModalContent";
import Button from '../../../partials/Button'
import Media from '../../../partials/Media'
import Instructions from "../../../partials/Instructions/Instructions";

const Questionnaire = ({ instructions, questions, initialMeters, onComplete, finalPopupData, introData }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [warningMessage, setWarningMessage] = useState(null);
  const [buttonText, setButtonText] = useState("Next");
  const [score, setScore] = useState(0);
  const [meters, setMeters] = useState({});
  const [answerGiven, setAnswerGiven] = useState(false);
  const [markers, setMarkers] = useState({});
  const [pageState, setPageState] = useState("Questionnare");

  const [retakeQuestionnaire, setRetakeQuestionnaire] = useState(false);
  const [isRight, setIsRight] = useState(null);

  console.log(warningMessage);

  const [shouldRetry, setShouldRetry] = useState(false);

  const populateMeters = () => {

    const newMeters = []
    initialMeters.forEach((meter) => {
        if(meter.meterText) {
          newMeters.push({ title: meter.meterText, value: meter.initialProgress })
        }
    });

    const markers = []
    initialMeters.forEach((meter) => {
        if(meter.KPIGoal) {
            markers.push({ title: meter.meterText, value: meter.KPIGoal })
        }
    });

    setMarkers(markers);
    setMeters(newMeters);
  };

  useEffect(() => {
    populateMeters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

  }, [open])

  const processNextStep = () => {
    setOpen(false);

    setIsRight(null);
    if (retakeQuestionnaire) {
      setRetakeQuestionnaire(false);
      setWarningMessage(null);
      setButtonText("Next");
    }

    if (currentQuestion === questions.length - 1) {
      setPageState("FinalPopup")
      setShouldRetry(checkForRetry());
      return;
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
      setAnswerGiven(false);
    } else {
      //onComplete()
    }
  };

  const checkForRetry = () => {

    const goalsMet = Object.keys(meters).every(function (key, index) {
      return meters[key].value >= initialMeters[index].KPIGoal
    });

    if (goalsMet) {
      return false
    } else {
      return true
    }
  };

  const onFinalClick = (retry) => {
    if (retry) {
      setCurrentQuestion(0);
      setOpen(false);
      setMessage(null);
      setWarningMessage(null);
      setScore(0);
      populateMeters();
      setAnswerGiven(false);
      setShouldRetry(false);
      setPageState("Questionnare")
    } else {
      onComplete();
    }
  }

  const changePageState = (state) => {
    setPageState(state);
  }

  const handleAnswerButtonClick = (answerOption, isCorrect) => {
    setAnswerGiven(false);

    const updatedMeters = meters.map((meter) => {

      if ((typeof answerOption.meters !== 'undefined' && answerOption.meters.length > 0)) {
        const answerMeters = answerOption.meters.find(option => meter.title === option.title)

        if (answerMeters) {
          const newValue = meter.value + answerMeters.value
          return { ...meter, value: (newValue > 100 ? 100 : newValue) }

        }
      }
      return meter
    })
    setMeters(updatedMeters);

    if (isCorrect) {
      
      setIsRight(true);
      setMessage(questions[currentQuestion].correctChoiceFeedback);
      setOpen(true);
      setScore(score + 1);

    } else {
      setIsRight(false);
      setMessage(questions[currentQuestion].wrongChoiceFeedback);
      setOpen(true);
    }


    setAnswerGiven(true);
  };
  return (
    <>
      <div className={`${styles.root} ${open ? styles.blur : ""}`}>
        {pageState === "Intro" &&
          <>
            <div className={styles.intro}>
              <div className={styles.intro_popup}>
                <div className={styles.intro_header}>
                  <h3>{introData.header}</h3>
                </div>
                <Scroll>
                  <HTMLContent className={styles.intro_body} html={introData.body} />
                </Scroll>
              </div>
              <div className={styles.intro_image}>
                <img alt={introData.alt} src={introData.image}></img>
              </div>
              <div className={styles.intro_button}>
                <Button className={styles.intro_button} text={introData.buttonText} onClick={() => setPageState("Questionnare")} />
              </div>
            </div>
          </>
        }
        {pageState === "Questionnare" &&
          <>
          <Instructions body={instructions} />
            <ColumnsLayout>
              <div className={styles.app}>
                <Scroll >
                  <div className={styles.question_scroll}>

                    <HTMLContent className={styles.question_header} html={questions[currentQuestion].headerText} />
                    <HTMLContent className={styles.question_text} html={questions[currentQuestion].questionText} />

                    <div className={styles.answer_section}>
                      {questions[currentQuestion].answerOptions.map(
                        (answerOption, index) => (
                          <BtnOptionSelect
                            disabled={answerGiven}
                            key={index}
                            className={styles.button_option_select}
                            onClick={() =>
                              handleAnswerButtonClick(
                                answerOption,
                                answerOption.isCorrect
                              )
                            }
                            dangerouslySetInnerHTML={{ __html: answerOption.answerText }}
                          />
                        )
                      )}
                    </div>

                  </div>
                
                </Scroll>
              </div>
              <div className={styles.img_section}>
                <Media
                  type= {questions[currentQuestion].mediaType}
                  src= {questions[currentQuestion].mediaUrl}
                  alt= {questions[currentQuestion].mediaAlt}
                />
              </div>
            </ColumnsLayout>
          </>
        }
        {
          pageState === "FinalPopup" && (
            <div className={styles.conclusion}>
              <div className={styles.final_popup}>
                <Scroll>
                <div className={styles.final_popup_scroll_content}>
                  <div className={styles.final_header}>
                    <h3>{finalPopupData[shouldRetry ? "incorrect" : "correct"].header}</h3>
                  </div>
                  <HTMLContent className={styles.final_body} html={finalPopupData[shouldRetry ? "incorrect" : "correct"].body} />
                </div>
                </Scroll>
              </div>
              <div className={styles.conclusion_image}>
                <img alt={finalPopupData[shouldRetry ? "incorrect" : "correct"].mediaAlt} src={finalPopupData[shouldRetry ? "incorrect" : "correct"].mediaUrl}></img>
              </div>
              <div className={styles.retry_button}>
                {shouldRetry?<Button className={styles.retry_button} text={finalPopupData[shouldRetry ? "incorrect" : "correct"].buttonText} onClick={() => onFinalClick(shouldRetry)} />:<></>}
                <Button className={styles.retry_button} text={finalPopupData["correct"].buttonText} onClick={() => onFinalClick(false)} />
              </div>
            </div>
          )
        }
      </div>
      {pageState !== "Intro" &&
        <ProgressBarContainer meters={meters} markers={markers} />
      }
      <Modal open={open}>
        <ModalContent
          isRight={isRight}
          message={message}
          warningMessage={warningMessage}
          onNextStepClick={processNextStep}
          buttonText={buttonText}

        />
      </Modal>
    </>
  );
};

export default Questionnaire;
